import { Form as FormikForm } from 'formik';
import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Scaffold = styled.section`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    height: 100%;
    overflow: auto;
    background-color: ${({ theme }) => theme.expense.background};
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const Title = styled.h5`
  text-align: center;
  font-weight: 600;
`;

export const Subtitle = styled.h5`
  max-width: 100%;
  margin: auto;
  font-size: 14px;
  text-align: center;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Form: any = styled(FormikForm)`
  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;
  }
`;

Form.Title = styled.h5`
  height: 32px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.24px;
  color: ${({ theme }) => theme.expense.values.title};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ConfirmBtn = styled(Button)`
  height: 56px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  margin-top: 48px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
    margin-left: auto;
  }

  &:disabled {
    cursor: initial;
  }
`;

export const DeleteBtn = styled.div`
  margin-top: 30px;
  height: 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: -0.2px;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.expense.deleteButton};
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
    margin-left: auto;
  }
`;
